import { useContext, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import LayoutContext from 'components/Layout/LayoutContext';
import { FullHeightContainer } from 'plataforma-fundacao-componentes';
import VideoPlayer from 'components/__ASSOCIADO__/Associado/VideoPlayer';

export default function AssessorTransmissao() {
  const location = useLocation();
  const { setToolbarReadOnly } = useContext(LayoutContext);

  const url = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('url');
  }, [location]);

  useEffect(() => {
    setToolbarReadOnly(true);
    return () => {
      setToolbarReadOnly(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FullHeightContainer>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            maxWidth: '1140px',
            padding: '26px',
            width: '100%',
            aspectRatio: '16 / 9',
          }}
        >
          {url && (
            <VideoPlayer url={url!} autoPlay blockRedirect={true} formatUrl />
          )}
        </div>
      </div>
    </FullHeightContainer>
  );
}
